module.exports = __webpack_public_path__ + "img/08—01—04—Diagnostic information > Telephony > French.255ecb15.jpg";